import React from 'react';

const GenericError = () => {
  return (
    <div>
      <h3>Något gick fel...</h3>
      <p>
        Försök att ladda om sidan. Kontakta oss gärna på kontakt@kthbok.com om
        problemet återstår.
      </p>
    </div>
  );
};

export default GenericError;
